module.exports = __webpack_public_path__ + "static/images/containers/Landing/components/LandingResult/images/landing-result-light.579c073e.png";


//////////////////
// WEBPACK FOOTER
// ./containers/Landing/components/LandingResult/images/landing-result-light.png
// module id = 3145
// module chunks = 11